import type { IconProps } from './../../models/icon';

export function CloseIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    width={width}
    height={height}
    className={className} 
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_183_1887)">
    <path d="M12 23.1429C18.1541 23.1429 23.1428 18.1541 23.1428 12C23.1428 5.84601 18.1541 0.857178 12 0.857178C5.84595 0.857178 0.857117 5.84601 0.857117 12C0.857117 18.1541 5.84595 23.1429 12 23.1429Z" fill={secondaryColor}/>
    <path d="M12 23.1429C18.1541 23.1429 23.1428 18.1541 23.1428 12C23.1428 5.84601 18.1541 0.857178 12 0.857178C5.84595 0.857178 0.857117 5.84601 0.857117 12C0.857117 18.1541 5.84595 23.1429 12 23.1429Z" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.6366 8.33398L8.3635 15.6071" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.36346 8.33398L15.6366 15.6071" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_183_1887">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>    
  );
}

